//# sourceMappingURL=ellipse.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/vector/ellipse.interface.js
// module id = 1195
// module chunks = 4